import React, { useState } from 'react'
import { getUploadFileURL, uploadDETCode, uploadDETCodeToS3 } from '../../../revampCRUD/Participants/DETCode.curd'
import { errorToaster } from '../../../reusable/common'
import { APIStatusCode } from '../../../services/util'
import UploadDETCodeModal from './UploadDETCodeModal'
import InvalidCodesModal from './InvalidCodesModal'
import { CustomModal } from '../../Atom/Modals'
import UploadSuccessfulModal from './UploadSuccessfulModal'
import UploadUnsuccessfulModal from './UploadUnsuccessfulModal'

const DETCodeModals = ({
    openDETModal,
    setOpenDETModal,
    DETAnalytics,
    eventId,
    loadModal,
    setScreen,
    screen,
    showOverview,
    redirectToDETCodePage
}) => {
    const [uploadedFile, setUploadedFile] = useState(null);
    const [loadingUploadFile, setLoadingUploadFile] = useState(false);
    const [uploadUrl, setUploadUrl] = useState(null);
    const [uploadedFileName, setUploadedFileName] = useState(null);
    const [loadSaveButton, setLoadSaveButton] = useState(false);
    const [storedDETData, setStoredDETData] = useState({})
    const [isSendConfirmationEmail, setIsSendConfirmationEmail] = useState(false)



    const getDETCodeURL = async (e) => {
        setLoadingUploadFile(true);
        const file = e?.target?.files[0];
        if (file) {
            setUploadedFile(file.name);
            const payloadUrl = {
                file_name: file.name,
                mime_type: file.type,
            };
            try {
                const url = await getUploadFileURL(eventId, payloadUrl);
                if (url.data.upload.url) {
                    setUploadUrl(url.data.upload.url)
                    setUploadedFileName(url.data.file_name)
                    const downloadUrl = await uploadDETCodeToS3(url.data.upload.url, file, payloadUrl.mime_type);
                    if (downloadUrl.status === APIStatusCode.STATUS_CODE_SUCCESS) setLoadingUploadFile(false);
                }
            } catch (error) {
                const errorMessage = error?.response?.data?.error || "Something went wrong";
                errorToaster(errorMessage)
            } finally {
                setLoadingUploadFile(false);
            }
        }
    };

    const handleUploadFile = async () => {
        setLoadSaveButton(true);

        const payload = {
            file_name: uploadedFileName,
            send_confirmation_email: isSendConfirmationEmail
        }

        try {
            const result = await uploadDETCode(eventId, payload);
            if (result.status === APIStatusCode.STATUS_CODE_SUCCESS) {
                setStoredDETData(result.data)
                if (result?.data?.valid_count > 0 && !result?.data?.invalid_count) {
                    setScreen("UploadedSuccessfully")
                }
                else if (result?.data?.valid_count > 0 && result?.data?.invalid_count > 0) {
                    setScreen("InValidDETCodes")
                }

            }
            setLoadSaveButton(false);

        } catch (error) {
            if (error?.response?.data?.error?.valid_count === 0 && error?.response?.data?.error?.message === "No valid DET Codes Found") {
                setStoredDETData(error?.response?.data?.error)
                setScreen("UploadedUnsuccessfully")
            }
            const errorMessage = error?.response?.data?.error || "Something went wrong";
            errorToaster(errorMessage)
            setLoadSaveButton(false);
        } finally {
            setLoadSaveButton(false);
        }
    }

    return (
        <>
            <CustomModal
                openModal={openDETModal}
                setOpenModal={setOpenDETModal}
                saveBtnDisabled={screen == 'UploadDETCodes' && uploadedFile == null}
                header={screen == 'UploadDETCodes' && "Upload DET Code"}
                paddingRequired="yes"
                overflow="auto"
                onClose={() => {
                    setScreen("UploadDETCodes")
                    setUploadedFile(null)
                    setIsSendConfirmationEmail(false)
                }}
                width={screen == "UploadDETCodes" ? "44%" : screen === "InValidDETCodes" ? "30%" : ""}
                content={
                    screen == "UploadDETCodes" ?
                        <UploadDETCodeModal
                            openDETModal={openDETModal}
                            setOpenDETModal={setOpenDETModal}
                            uploadedFile={uploadedFile}
                            loadModal={loadModal}
                            DETAnalytics={DETAnalytics}
                            loadingUploadFile={loadingUploadFile}
                            loadSaveButton={loadSaveButton}
                            uploadUrl={uploadUrl}
                            getDETCodeURL={getDETCodeURL}
                            handleUploadFile={handleUploadFile}
                            showOverview={showOverview}
                            setIsSendConfirmationEmail={setIsSendConfirmationEmail}
                            isSendConfirmationEmail={isSendConfirmationEmail}
                            setUploadedFile={setUploadedFile}
                        /> : screen === "UploadedSuccessfully" ?
                            <UploadSuccessfulModal
                                redirectToDETCodePage={redirectToDETCodePage}
                                eventId={eventId}
                            />
                            : screen === "InValidDETCodes" ?
                                <InvalidCodesModal
                                    storedDETData={storedDETData}
                                /> : screen === "UploadedUnsuccessfully" &&
                                <UploadUnsuccessfulModal
                                    storedDETData={storedDETData}
                                />
                }
            />

        </>
    )
}

export default DETCodeModals